import { SearchPageSortOptions } from '../types';
import { SearchSortItem } from '../components/SearchStickySortMenuSelect/SearchStickySortMenuSelect';

export const getSortOptionsByPropertyStatus = (
  sortOptions: SearchPageSortOptions,
  propertyStatus?: string,
): SearchSortItem[] => {
  switch (propertyStatus) {
    case 'FOR_SALE':
      return sortOptions.forSale?.options ?? [];
    case 'FOR_RENT':
      return sortOptions.forRent?.options ?? [];
    case 'SOLD':
      return sortOptions.sold?.options ?? [];
    case 'OFF_MARKET':
      return sortOptions.offMarket?.options ?? [];
    case 'ALL':
      return sortOptions.allPropertyStatuses?.options ?? [];
    default:
      return [];
  }
};
